module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/grid-9.png?5c54e360";